module.exports = __webpack_public_path__ + "img/logo.717253e4.png";